import type { InjectionKey, Ref } from 'vue'

/**
 * Provided by Carousel so its slides can render their own controls and drive the
 * scroller without reaching for the parent component instance.
 */
export interface CarouselContext {
  // Carousel's `theme` prop — slides opt into behaviour based on it (e.g. `hero-slider`)
  theme: Readonly<Ref<string | null>>
  // The scrolling element. Slides are its direct children, so it doubles as the
  // check for "am I a slide of this carousel, or just nested somewhere inside it"
  contents: Readonly<Ref<HTMLElement | null>>
  // Scroll to a slide by its 0-based index
  scrollTo: (index: number, smooth?: boolean) => void
}

export const carouselContextKey = Symbol('carousel') as InjectionKey<CarouselContext>
